import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikCalibrateColorSensor extends ASTBlock {
    constructor(color) {
        super(color, "alvik_calibrate_color_sensor")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "kalibriere den Farbsensor auf %1 Boden %2",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "background_color",
                    "options": [
                        [
                            "weißem",
                            "white"
                        ],
                        [
                            "schwarzem",
                            "black"
                        ]
                    ]
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "previousStatement": null,
            "nextStatement": null
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}